import { ApolloError, useQuery } from '@apollo/client';

import { MetricsStatus, MetricsStatusQuery, MetricsStatusQueryVariables } from '../types';
import { METRICS_STATUS } from './metricsStatus';

type UseMetricsStatusResponse = {
  data?: MetricsStatus;
  loading: boolean;
  error?: ApolloError;
};

const useMetricsStatus = (organizationId: string, adAccountIds: Array<string>): UseMetricsStatusResponse => {
  const { data, error, loading } = useQuery<MetricsStatusQuery, MetricsStatusQueryVariables>(METRICS_STATUS, {
    variables: {
      metricsStatusRequest: {
        organizationId,
        adAccountIds,
      },
    },
    skip: !adAccountIds?.length,
  });

  return {
    data: data?.getMetricsStatus,
    loading,
    error,
  };
};

export default useMetricsStatus;
